import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  RmmComputersStatistic,
  RmmPageFieldsResponse,
  RmmPageFilterItemField,
  RmmPageGetDataQueryParams,
  RmmPageGetDataResponse,
  RmmPageQueryPayload,
  RmmPageQueryResponse,
  RmmPageTemplate
} from 'mbs-ui-shared@models/rmm-warehouse.models';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class RmmComputersService {
  private http = inject(HttpClient);
  private config = inject(ConfigurationService);

  private baseApiURL = `${this.config.get('rmmWarehouse')}/api/v1/`;

  getAvailableFields(): Observable<RmmPageFieldsResponse> {
    return this.http.get<RmmPageFieldsResponse>(`${this.baseApiURL}fields`);
  }

  getPresets(): Observable<RmmPageQueryResponse> {
    return this.http.get<RmmPageQueryResponse>(`${this.baseApiURL}computer-page/views`);
  }

  savePreset(payload: RmmPageQueryPayload): Observable<RmmPageTemplate> {
    return this.http.post<RmmPageTemplate>(`${this.baseApiURL}computer-page/views`, payload);
  }

  updatePreset(id: string, payload: RmmPageQueryPayload): Observable<RmmPageTemplate> {
    return this.http.put<RmmPageTemplate>(`${this.baseApiURL}computer-page/views/${id}`, payload);
  }

  deletePreset(id: string): Observable<unknown> {
    return this.http.delete<unknown>(`${this.baseApiURL}computer-page/views/${id}`);
  }

  getData(payload: RmmPageGetDataQueryParams): Observable<RmmPageGetDataResponse> {
    return this.http.request<RmmPageGetDataResponse>('POST', `${this.baseApiURL}computer-page/views/results`, {
      body: payload
    });
  }

  getStatistic(filter: RmmPageFilterItemField | null): Observable<RmmComputersStatistic> {
    return this.http.post<RmmComputersStatistic>(`${this.baseApiURL}computers/statistic`, { filter });
  }

  getDataFromTemplate(templateId: string, query: { page: number; pageSize: number }): Observable<RmmPageGetDataResponse> {
    return this.http.get<RmmPageGetDataResponse>(`${this.baseApiURL}computer-page/views/${templateId}/results`, {
      params: query
    });
  }
}
